import axios from 'axios';
import { BusinessUnitTier, RawBusinessUnitDetails } from '../models';
import { getAuthHeaders } from '../utils/apiUtils';

const host = process.env.REACT_APP_ApiUrl || '';

export const getBusinessUnitTier = async (businessUnitId: string)
: Promise<BusinessUnitTier | null> => {
  const url = `${host}/v1/private/business-units/${businessUnitId}/tier`;
  try {
    const res = await axios.get(url, { headers: getAuthHeaders() });
    return res.data;
  } catch (e) {
    console.log(`Failed to retrieve business unit tier details. Url: ${url} Reason: ${e.message}`);
    throw e;
  }
};

export const getBusinessUnitDetails = async (businessUnitId: string)
: Promise<RawBusinessUnitDetails> => {
  const url = `${host}/v1/private/business-units/${businessUnitId}`;

  try {
    const result = await axios.get(url, { headers: getAuthHeaders() });
    return result.data;
  } catch (e) {
    console.log(`Failed to retrieve business unit details. Url: ${url} Reason: ${e.message}`);
    throw e;
  }
};
